export class car {
    public GoogleResponseToken: string;
    public licensePlate: string;
}